import request from './request';

/**
 * 获取短信验证码
 * 后端接口：/captcha/captchaSms
 * @param {String} phonenumber - 手机号
 * @returns {Promise} 返回请求结果Promise对象
 */
export function getSmsCaptcha(phonenumber) {
  return request({
    url: '/captchaSms',
    method: 'get',
    params: { phonenumber }
  });
}

